module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employee/templates/payslips/Payslips.ejs -->\n<div class="ibox-content">\n    <div class="row">\n        ';
 payslips.each(function(payslip, index) { 
__p+='\n            ';
 var pdf = attachments[payslip.id].first() 
__p+='           \n            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">\n                '+
((__t=( require('commons/templates/PayslipCard.ejs')({
                    payslip: payslip,
                    payslipPdf: pdf,
                    viewUrl: '#view/' + payslip.id
                }) ))==null?'':__t)+
'\n            </div>\n        ';
 }) 
__p+='\n        \n    </div>\n    ';
 /* FIXME: apparently we dont render payslips of payrolls whose status
        * isnt 8. If those payslips can be part of the collection just checking
        * length here doesnt cut it
        */ 
__p+='\n    ';
 if (payslips.length === 0) { 
__p+='\n        <div class="row">\n            <div class="col-xs-12">\n                <h2>There are currently no payslips</h2>\n            </div>\n        </div>\n    ';
 } 
__p+='\n    <div class="row">\n        <div class="col-xs-12">\n            '+
((__t=( require('commons/templates/Paginator.ejs')({ pagination: pagination, items: 'payslips' }) ))==null?'':__t)+
'\n        </div>\n    </div>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employee/templates/payslips/Payslips.ejs
// module id = 1059
// module chunks = 1